import { render, staticRenderFns } from "./AppPrzewodnikTurystyczny.vue?vue&type=template&id=4e24bb14&"
import script from "./AppPrzewodnikTurystyczny.vue?vue&type=script&lang=js&"
export * from "./AppPrzewodnikTurystyczny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports